//@ts-strict-ignore
import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { SohoTabsComponent, } from 'ids-enterprise-ng';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMBannerHeaderComponentRef } from '@banner/lm-banner-header-component-ref.service';
import { LMContextService } from '@services/lm-context.service';
import {
  LMLoggerService,
  LMBusyIndicatorService,
  LMErrorUtilService,
  LMRouteComponentService,
  LMComponentInfoService,
  RoamingUIProfileResponse,
  RoamingUIProfileResult,
  LMRoamingUIProfileService,
  LMFormatUtilService,
  LMSpecService,
  LMUrlUtilService,
  LMActionService,
  LMModalOpenService,
  LMModalWrapperService
} from '@app/services';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { BehaviorSubject, forkJoin, lastValueFrom, Observable, of, Subscription } from 'rxjs';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { AppConstants, LMGlobalUtilService, LMUniqueIdService } from '@app/utils';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import {
  LMBuilderService,
  LMListComponent,
  LMListContext,
  LMListTransactionService,
  LMPrintDialogService,
  LMReportPersonalizationDialogResult,
  LMReportPersonalizationDialogResultCode,
  LMReportPersonalizationDialogService,
  SaveRequired
} from '@app/components';
import { LMCreateReportDialogService } from '@report/index';
import { LMReportsListComponent } from './lm-reports-list.component';
import { LMReportsCatalogToolbarService } from './lm-reports-catalog-toolbar.service';
import { LMReportsCatalogService } from './lm-reports-catalog.service';
import {
  LMPersonalizationDialogOption,
  LMReport,
  LMReportCategoriesByModule,
  LMReportDefListSpec,
  LMReportsResponse,
} from '../lm-reports';
import { LMGlobalPersonalization } from '@app/states';
import { LMTransactionState } from '@app/transaction';
import { LMComponentTrackerService } from '@services/lm-component-tracker.service';
import { catchError } from "rxjs/operators";
import {ListResource} from "@app/resources";

@Component({
  selector:    'lm-reports-catalog',
  standalone: false,
  templateUrl: './lm-reports-catalog.component.html',
  styleUrls:   [ 'lm-reports-catalog.component.scss' ],
  providers:   [
  LMReportsCatalogToolbarService,
  LMRoamingUIProfileService,
  LMComponentTrackerService
  ],
  })
export class LMReportsCatalogComponent extends LMBaseComponent implements AfterViewInit, OnInit, OnDestroy, SaveRequired {

  // ---------------------
  // Page layout variables
  // ---------------------
  private toolbarButtonSubscription: Subscription;
  initialized = false;
  public displayDataGrid = false;
  public toolbarButtons: Observable<Array<LMToolbarButton>>;
  private toolbarActionRefArray: Array<LMBusActionReference> = [];
  private subscriptionsArray: Array<Subscription> = [];
  public pageTitle = Soho.Locale.translate('ReportCatalog');
  private screenId = 'ReportCatalog';
  public globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
  public catalogTabTitle = Soho.Locale.translate('Reports');
  public printFilesTabTitle = Soho.Locale.translate('PrintFiles');
  private initializeSohoTabs = true;
  public doRetrievePrintFilesSpec = true;
  public TAB_ID_ALLREPORTS = 'lm-allreports-tab-content';
  public TAB_ID_PRINTFILES = 'lm-printfiles-tab-content';
  public disableReportTab = false;

  // --------------------------
  // WebApp/Category Tab variables
  // --------------------------
  public reportsArray: Array<LMReport> = [];
  public categoriesByModule: LMReportCategoriesByModule;

  // -----------------------------
  // Create Report modal variables
  // -----------------------------
  private createReportUrl: string;
  private actorGroupSelectUrl: string;
  private roleSelectUrl: string;
  private roleGroupSelectUrl: string;
  private reportFieldSearchUrl: string;

  private PRINT_FILES_LIST = 'UserReport.UserCompletedReportsCatalogList';
  private PRINT_QUEUE_LIST = 'AsyncActionRequest.MyReportDocumentUnfinishedNonScheduledList';
  private PRINT_SCHEDULE_LIST = 'AsyncActionRequest.MyReportDocumentScheduledList';
  private printFilesResponse: LMListSpecResponse;
  private printQueueResponse: LMListSpecResponse;
  private printScheduleResponse: LMListSpecResponse;
  public printFilesListSpec: LMListSpec;
  public printQueueListSpec: LMListSpec;
  public printScheuduleListSpec: LMListSpec;
  public printFilesListUrlInfo: LMListUrlInfo;
  public printQueueListUrlInfo: LMListUrlInfo;
  public printScheduleListUrlInfo: LMListUrlInfo;
  private REPORT_CATALOG_DATA_LIST = 'ReportDefinition.ReportCatalogDataList';
  private readonly instanceId: string;
  private updateAllReports = false;
  private dirtyCheckComplete = false;
  showScheduledWidget= true;
  @ViewChild('LMPrintCompletedListComponent') lmListPrintCompletedComponent: LMListComponent;
  @ViewChild('LMPrintQueueListComponent') lmListPrintQueueComponent: LMListComponent;
  @ViewChild('LMPrintScheduledListComponent') lmListPrintScheduledComponent: LMListComponent;
  @ViewChild(LMToolbarComponent) toolbar: LMToolbarComponent;
  @ViewChild(SohoTabsComponent) tabs: SohoTabsComponent;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef, static: true }) modalPlaceholder: ViewContainerRef;
  @ViewChildren(LMReportsListComponent) lmReportsListComponents: QueryList<LMReportsListComponent>;

  @HostBinding('class.form-layout-compact') @Input() useCompactFormLayout: boolean;
  @HostBinding('class.lm-display-type-is-smartphone') displayTypeIsSmartPhone: boolean;

  constructor(
    public    router: Router,
    public    route: ActivatedRoute,
    private   lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    private   lmReportsCatalogToolbarService: LMReportsCatalogToolbarService,
    public    lmContextService: LMContextService,
    private   lmContextUtilService: LMContextUtilService,
    private   lmCreateReportDialogService: LMCreateReportDialogService,
    private   lmErrorUtilService: LMErrorUtilService,
    private   lmFormatUtilService: LMFormatUtilService,
    private   lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private   lmGlobalUtilService: LMGlobalUtilService,
    private   lmLoggerService: LMLoggerService,
    private   lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    private   lmRoamingUIProfileService: LMRoamingUIProfileService,
    private   lmRouteComponentService: LMRouteComponentService,
    private   lmSpecService: LMSpecService,
    private   lmUrlUtilService: LMUrlUtilService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    private   lmReportsCatalogService: LMReportsCatalogService,
    protected lmAppComponentService: LMAppComponentService,
    private   lmPrintDialogService: LMPrintDialogService,
    private   lmListTransactionService: LMListTransactionService,
    private   lmActionService: LMActionService,
    private   lmComponentTrackerService: LMComponentTrackerService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService,
    protected lmBuilderService:LMBuilderService,
  ) {
    super (lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
    this.instanceId = this.lmLoggerService.instanceId;
    this.disableReportTab = this.disableReportsTab();
    // setTimeout(() => {
    //   this.zone.run(() => {
    //     this.changeDetectionRef.detectChanges();
    //   });
    // });
  }

  get reportsArray$(): Observable<LMReport[]> {
    return this.lmReportsCatalogService.reportsArray$;
  }

  get categoriesByModule$(): Observable<LMReportCategoriesByModule> {
    return this.lmReportsCatalogService.categoriesByModule$;
  }

  get printFilesEnabled(): boolean {
    const context = this.lmContextService.getContext();
    return !context.isWFMStandaloneWebapp && !context.configuredFeatures.includes('HideMenuPrintFiles');
  }

  ngOnInit() {
    this.lmLoggerService.time({ id: '>> Reports Catalog' + this.instanceId});
    this.retrieveReportsCatalogSpecJSON();
    this.lmRouteComponentService.setRouteComponent(this as Component);
    this.lmBusyIndicatorService.showBusyIndicator();
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
    this.displayTypeIsSmartPhone = this.lmContextService.isMobileDevice();
    this.showScheduledWidget = this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ShowAllScheduleActions);
  }

  ngAfterViewInit() {
    const context = this.lmContextService.getContext();
    const configuredFeatures = context.configuredFeatures;
    const createReportEnabled = configuredFeatures.includes(AppConstants.FEATURE_CreateReport);

    if (createReportEnabled && !context.isWFMStandaloneWebapp) {
      if (this.lmContextService.getContext().useNewReportBuilder) {
        this.toolbarActionRefArray = [
          {
            id: 'reports-catalog-create-beta',
            automationId: 'reports-catalog-create-beta',
            icon: 'create',
            label: Soho.Locale.translate('CreateReportBeta'),
            type: 'standard',
          },
          {
            id: 'reports-catalog-create',
            automationId: 'reports-catalog-create',
            icon: 'create',
            label: Soho.Locale.translate('CreateReport'),
            type: 'standard',
          },
          {
            id: 'reports-catalog-refresh',
            automationId: 'reports-catalog-refresh',
            icon: 'refresh',
            type: 'standard',
          }
        ];
      } else {
        this.toolbarActionRefArray = [
          {
            id: 'reports-catalog-create',
            automationId: 'reports-catalog-create',
            icon: 'create',
            label: Soho.Locale.translate('CreateReport'),
            type: 'standard',
          },
          {
            id: 'reports-catalog-refresh',
            automationId: 'reports-catalog-refresh',
            icon: 'refresh',
            type: 'standard',
          }
        ];
      }
    } else {
      if (!context.isWFMStandaloneWebapp) {
        this.toolbarActionRefArray = [
          {
            id: 'reports-catalog-refresh',
            automationId: 'reports-catalog-refresh',
            icon: 'refresh',
            type: 'standard',
          } ];
      }
    }

    this.buildToolBar();
    this.sendShortcut();
    // setTimeout(() => {this.initialized = true;});
  }

  ngAfterViewChecked() {
    this.initializeTabs();
  }

  private initializeTabs() {
    if (this.initializeSohoTabs && this.tabs && this.tabs.getVisibleTabs().length > 0) {
      this.initializeSohoTabs = false;
      let activeTab = this.lmReportsCatalogService.getActiveTab();
      const paramTab = this.lmUrlUtilService.getUrlParam(window.location.href, 'selectedPanel');
      if (paramTab) {
        activeTab = 'lm-' + paramTab + '-tab-content';
      }
      if (activeTab) {
        this.tabs.select(activeTab, true);
      } else {
        this.tabs.select(this.TAB_ID_ALLREPORTS, true);
      }
      this.tabs.disableAutoUpdatedCall = true;
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }

  ngOnDestroy() {
    if (this.lmBannerHeaderCompRef && this.lmBannerHeaderCompRef.instance) {
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = '';
    }
    this.subscriptionsArray.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.lmReportsCatalogToolbarService.reset();
    if (this.lmContextService.isTrackerEnabled()) {
      this.lmComponentTrackerService.endComponentTracking();
    }
    setTimeout(() => {
      this.lmBannerHeaderCompRef = undefined;
    });
  }

  private retrieveReportsCatalogSpecJSON(): void {
    this.lmBusyIndicatorService.showBusyIndicator();

    this.subscriptionsArray.push(
      this.lmReportsCatalogService.getReportsCatalogData().subscribe((response: LMReportsResponse) => {
        if (response.status === 'SUCCESS') {
          this.initialized = true;
          this.displayDataGrid = true;
          this.unpackSpec(response);
        }

        if (!this.initializeSohoTabs) {
          this.lmBusyIndicatorService.hideBusyIndicator();
        }

        this.pageAnalytics();
      })
    );
  }

  private unpackSpec(spec: LMReportsResponse): void {
    this.setCreateReportUrls(spec['createReportUrls']);
  }

  private sendShortcut(): void {
    const shortcutTitle = `${this.pageTitle} / ${this.lmContextService.getContext().webAppTitle}`;
    this.lmContextUtilService.enableStandardShortcut(true, shortcutTitle);
  }

  onSendContextMessageEvent(event: any) {
    this.sendBusinessContext(event);
  }

  public sendBusinessContext(contextMsgs?: any): void {
    this.lmContextUtilService.clearAll();
    this.lmContextUtilService.buildContextMessages({
      busFormName:           this.screenId,
      busClassName:          this.lmContextService.getContext().webApp, // since no busclass for a page use webApp name.
      widgetEventPrefix:     AppConstants.RESOURCETYPE_REPORTCATALOG,
    })
      .subscribe((msgObj: any) => {
        if (msgObj.status === AppConstants.STATUS_COMPLETED) {
          if (contextMsgs) {
            msgObj = this.lmContextUtilService.mergeContextMessages({ sourceMsgs: msgObj, addMsgs: contextMsgs });
          }
          this.lmContextUtilService.sendContextMessages(msgObj);
        }
      });
  }

  private retrievePrintPanelSpecs() {
    const observables: Observable<any>[] = [];
    observables.push(this.retrievePrintFilesSpec().pipe(catchError(error => of(this.handleSpecResponseError(error)))));
    observables.push(this.retrievePrintQueueSpec().pipe(catchError(error => of(this.handleSpecResponseError(error)))));

    if (this.showScheduledWidget) {
      observables.push(this.retrievePrintScheduleSpec().pipe(catchError(error => of(this.handleSpecResponseError(error)))));
    }

    forkJoin(observables).subscribe(results => {
      this.displayDataGrid = true;
      if (!this.initializeSohoTabs) {
        this.lmBusyIndicatorService.hideBusyIndicator();
      }
    });
  }

  private retrievePrintFilesSpec(): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.lmReportsCatalogService.getListSpec(this.PRINT_FILES_LIST)
          .subscribe((response) => {
            this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog retrievePrintFilesSpec() completed', response ]);
            if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
              this.handleSpecResponseError((response as LMSystemException));
              observer.error(response);
              observer.complete();
            } else {
            this.printFilesResponse = response;
            this.printFilesListSpec = this.printFilesResponse.listSpec;
            this.printFilesListUrlInfo = this.printFilesResponse.listUrlInfo;
            observer.next(true);
            observer.complete();
            }
          });
    });
  }

  private retrievePrintQueueSpec(): Observable<boolean> {
    return new Observable<boolean>(observer => {
     this.lmReportsCatalogService.getListSpec(this.PRINT_QUEUE_LIST)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog retrievePrintQueueSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            observer.error(response);
            observer.complete();
          } else {
            this.printQueueResponse = response;
            this.printQueueListSpec = this.printQueueResponse.listSpec;
            this.printQueueListSpec.listType = 'dashboard';
            this.printQueueListUrlInfo = this.printQueueResponse.listUrlInfo;
            observer.next(true);
            observer.complete();
          }
        });
    });
  }

  private retrievePrintScheduleSpec() {
    return new Observable<boolean>(observer => {
      this.lmReportsCatalogService.getListSpec(this.PRINT_SCHEDULE_LIST)
          .subscribe((response) => {
            this.lmLoggerService.trace([this, this.instanceId, 'ReportsCatalog retrievePrintScheduleSpec() completed', response]);
            if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
              observer.error(response);
              observer.complete();
            } else {
              this.printScheduleResponse = response;
              this.printScheuduleListSpec = this.printScheduleResponse.listSpec;
              this.printScheuduleListSpec.listType = 'dashboard';
              this.printScheduleListUrlInfo = this.printScheduleResponse.listUrlInfo;
              observer.next(true);
              observer.complete();
            }
          });
    });
  }

  private buildToolBar() {
    if (this.lmContextService.inMingleWidget()) {
      return;
    }
    this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmReportsCatalogToolbarService.getToolbarButtonsObservable();

    setTimeout(() => {
      // need to place in a timeout so the toolbarService has a change to set its observable member.
      this.lmBannerHeaderCompRef.instance.screenId = this.screenId;
      this.lmBannerHeaderCompRef.instance.screenAutomationId = this.screenId;
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.pageTitle;
      this.lmReportsCatalogToolbarService.buildToolbar(this.toolbarActionRefArray);
      if (!this.lmContextService.isBannerInRoute() && this.lmContextService.showBreadcrumbs()) {
        this.lmBannerHeaderCompRef.resetBreadCrumbs('ReportCatalog');
        this.lmBannerHeaderCompRef.updateBreadcrumbs({
          id: undefined,
          category: 'ReportCatalog',
          busClass: '',
          specName: 'ReportCatalog',
          type: 'SYSTEM',
          title: this.pageTitle,
          routeUrl: this.router.url
        });
      }
      this.subscriptionsArray.push(this.lmBannerHeaderCompRef.instance.toolbarButtonEvent.subscribe((e) => {
        if (e.actionReference?.id === 'reports-catalog-create') {
          this.runCreateReport();
        } else if (e.actionReference?.id === 'reports-catalog-create-beta') {
          this.runCreateReportBeta();
        } else if (e.actionReference?.id === 'reports-catalog-refresh') {
          this.runRefresh();
        }
      }));
    }, 1);
    const globalPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    if (globalPersonalization.color === 'alabaster' || (!globalPersonalization.color && this.lmContextService.getContext().theme !== 'Dark')) {
      setTimeout(() => { // Make "Create Report" button primary if toolbar is white
        const toolbar = document.getElementsByClassName('flex-toolbar-main-app-content')[0];
        const buttonsContainer = toolbar?.getElementsByClassName('toolbar-section buttonset')[0];
        const buttons = buttonsContainer?.getElementsByClassName('btn');
        for (const buttonsKey in buttons) {
          if (buttons[buttonsKey] && buttons[buttonsKey] instanceof Object) {
            const btn = (buttons[buttonsKey]) as HTMLElement;
            if (btn.classList && 'reports-catalog-create_toolbar_button' === btn.getAttribute('id')) {
              btn.classList.add('btn-primary');
              btn.classList.add('lm-report-toolbar');
            }
          }
        }
      }, 1);
    }
  }

  private reloadReports() {
    this.lmLoggerService.time({ id: '>> Reports Catalog' + this.instanceId});
    this.retrieveReportsCatalogSpecJSON();
  }

  public runCreateReportBeta() {
    const facadeExplorerUrl = this.lmUrlUtilService.getFacadeUrl('Explorer');
    this.lmGlobalUtilService.navigateByUrl(facadeExplorerUrl);
    this.lmContextService.setClearNextPageState(true);
  }

  // Triggered by clicking "Create Report" in toolbar, see runCreateReport() in lm-application-menu-base
  public runCreateReport(): void {
      this.lmCreateReportDialogService.openCreateReportDialog(
          'createReportFromBanner',
          this.modalPlaceholder,
          this.createReportUrl,
          this.actorGroupSelectUrl,
          this.roleSelectUrl,
          this.roleGroupSelectUrl,
          this.reportFieldSearchUrl
      ).subscribe((result: LMReportPersonalizationDialogResult) => {
        if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
          if (result.viewReport) {
            this.lmContextService.setClearNextPageState(true, false);
            this.lmGlobalUtilService.navigateByUrl(result.reportUrl);
          } else {
            this.reloadReports();
            this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
          }
        }
        return;
      });
  }

  public canRefresh(): boolean {
    return this.lmReportsCatalogToolbarService.hasToolbarAction('reports-catalog-refresh');
  }

  public runRefresh(): void {

    if ('lm-printfiles-tab-content' === this.lmReportsCatalogService.getActiveTab()) {
      this.refreshPrintFilePage();
    } else {
      this.reloadReports();
    }
  }

  private refreshPrintFilePage() {
      this.lmListPrintCompletedComponent?.refresh().subscribe();
      this.lmListPrintQueueComponent?.refresh().subscribe();
      this.lmListPrintScheduledComponent?.refresh().subscribe();

  }
  onReportListEvent($event: any) {
    if ($event.type === 'favoriteClicked') {
      this.onFavoriteClicked($event.item);
    } else if ($event.type === 'emptyStateClicked') {
      this.onEmptyStateClicked($event.value);
    } else if ($event.type === 'deleteReport') {
      this.deleteUserFolderReport($event.item);
    } else if ($event.type === 'runPersonalization') {
      this.runReportPersonalization($event.item, undefined, false);
    } else if ($event.type === 'exportToCsv' || $event.type === 'printToPdf') {
      this.runReportsExportAction($event.item, $event.type);
    } else if ($event.type === 'reassignReportOwner') {
      this.runReportDefinitionAction($event.item, $event.type, 'ReassignReportOwner');
    } else if ($event.type === 'visitReport') {
      // Updates relevant RecentReport record, doesn't actually navigate the user anywhere
      this.runReportDefinitionAction($event.item, $event.type, 'VisitReport');
    } else if ($event.type === 'copy') {
      this.runCopyReport($event.item);
    } else if ($event.type === 'viewPersonalization') {
      this.runReportPersonalization($event.item, undefined, true);
    }
  }

  private onFavoriteClicked(report: LMReport) {
    this.lmReportsCatalogService.updateFavorites(report);
    this.updateRoamingUIProfileFavorites();
  }

  private updateRoamingUIProfileFavorites() {
    this.lmRoamingUIProfileService.setFavoriteReports(this.lmReportsCatalogService.getFavorites().toString())
      .subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          } else {
            this.lmLoggerService.log('Warning: RoamingUIProfile NOT Updated');
          }
        });
  }

  private onEmptyStateClicked(action: string){
    if (action === 'switch-tab') {
      this.tabs.select(this.TAB_ID_ALLREPORTS);
    } else if (action === 'create-report') {
      this.runCreateReport();
    }
  }

  private deleteUserFolderReport(report: LMReport ) {
    this.lmReportsCatalogService.deleteUserFolderReport(report.id)
      .subscribe(
        (response: any) => {
          if (response.status === AppConstants.STATUS_COMPLETED) {
            this.lmReportsCatalogService.removeReport(report);
            const message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('DeleteActionCompleteSuccessResults'), "1");
            this.lmGlobalUtilService.displayToastMessage('', message);
          } else {
            this.lmGlobalUtilService.displayToastMessage('', 'Unable to delete report');
          }
        }
      );
  }

  /* Enter here one of three ways:
      1. Copy (event = copy; param = {}; isReadOnly = false)
      2. Edit (event = runPersonalization; param = undefined; isReadOnly = false)
      3. View (event = viewPersonalization; param = undefined; isReadOnly = true)
   */
  private runReportPersonalization(report: LMReport, param?: LMPersonalizationDialogOption, isReadOnly?: boolean) {
    // Retrieve list spec before running dialog
    if (this.lmContextService.getContext().useNewReportBuilder && !isReadOnly) {
      this.lmReportsCatalogService.getReportListType(report).subscribe(response => {
        if (response.listType === 'live' || response.listType === 'columnar') {
          const resourceId = report.resourceId;
          const listResource = new ListResource({resourceId: resourceId});
          const url = this.lmBuilderService.getPersonalizeSpecUrl(listResource, report.id);
          this.lmGlobalUtilService.navigateByUrl(url);
        } else {
          this._runReportPersonalization(report, param, isReadOnly);
        }
      });
    } else {
        this._runReportPersonalization(report, param, isReadOnly);
    }
  }

  private _runReportPersonalization(report: LMReport, param?: LMPersonalizationDialogOption, isReadOnly?: boolean) {
    const url = this.lmReportsCatalogService.buildReportUrl(report);
    this.lmSpecService.getListSpec(url)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog > runReportPersonalization > getListSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.handleSpecResponseError((response as LMSystemException));
            return;
          }
          const listSpec = (response as LMListSpecResponse).listSpec;
          const listUrlInfo = (response as LMListSpecResponse).listUrlInfo;

          const mode = param?.mode || 'personalizeReport';
          const reportType = param?.reportType;
          const busClassName = report?.busClass;
          const listName = listSpec?.busListSpec?.name;
          const userFolderId = report.id;
          const title = listSpec.busListSpec.title.resourceValue + (param?.reportType === 'ReportCopiedFromReport' || param?.reportType === 'ReportCopiedFromList' ? '_Copy' : '');
          const personalizationExists = mode === 'personalizeReport';
          const createReportMode = mode === 'createReportFromMenu';

          this.lmReportPersonalizationDialogService.runReportPersonalizationDialog(
              mode,
              this.modalPlaceholder,
              reportType,
              busClassName,
              listName,
              userFolderId,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              title,
              listUrlInfo,
              listSpec,
              undefined,
              undefined,
              personalizationExists,
              listSpec.includeBaseFilter,
              listSpec.filterCondition,
              undefined,
              isReadOnly,
              createReportMode
          ).subscribe((result: LMReportPersonalizationDialogResult) => {
            if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
              this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
              this.reloadReports();
            }
          });
        });
  }

  private runReportsExportAction(report: LMReport, type: string) { // Note: only valid for lists
    this.lmBusyIndicatorService.showBusyIndicator();

    const url = this.lmReportsCatalogService.buildReportUrl(report);
    if (report.type.toUpperCase() === 'LIST') {
      this.lmSpecService.getListSpec(url)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog > runReportsExportAction > getListSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.handleSpecResponseError((response as LMSystemException));
            return;
          }
          const listSpec = (response as LMListSpecResponse).listSpec;
          const listUrlInfo = (response as LMListSpecResponse).listUrlInfo;
          if (type === 'exportToCsv') {
            const settings = this.lmReportsCatalogService.buildListCsvSettings(report, listSpec, listUrlInfo, this.modalPlaceholder);
            this.lmPrintDialogService.openCsvDialog(settings);
          } else if (type === 'printToPdf') {
            const settings = this.lmReportsCatalogService.buildListPdfSettings(report, listSpec, listUrlInfo);
            this.lmPrintDialogService.openPdfDialog(settings);
          }
          this.lmBusyIndicatorService.hideBusyIndicator();
        });
    } else {
      this.lmLoggerService.log('Unable to export report; Invalid report type: ' + report.type);
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }


  private runReportDefinitionAction(report: LMReport, type: string, actionName: string) {
    this.lmBusyIndicatorService.showBusyIndicator();

    let reportDefListSpecObj: LMReportDefListSpec = this.lmReportsCatalogService.getReportDefListSpecObj();

    if (!reportDefListSpecObj) {
      this.lmReportsCatalogService.getListSpec(this.REPORT_CATALOG_DATA_LIST)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog getReportDefinitionDataListSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.handleSpecResponseError((response as LMSystemException));
            return;
          }
          reportDefListSpecObj = {
            reportDefinitionListSpec: response.listSpec,
            reportDefinitionListUrlInfo: response.listUrlInfo
          };
          this.lmReportsCatalogService.setReportDefListSpecObj(reportDefListSpecObj);

          this.runReportDefinitionAction(report, type, actionName); // Recursive call
        });
    } else {
      this.lmReportsCatalogService.getReportDefinitionRecordDataView(report)
        .subscribe((listPagingResponse: LMListPagingResponse) => {
          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }
          this.lmBusyIndicatorService.hideBusyIndicator();

          if (listPagingResponse.status === 'COMPLETED' && listPagingResponse.dataViewSet) {
            const listContext: LMListContext = {
              listUrlInfo: reportDefListSpecObj.reportDefinitionListUrlInfo,
              listSpec:    reportDefListSpecObj.reportDefinitionListSpec
            };
            const actionSpec: LMActionSpec = this.lmActionService.getActionByName(reportDefListSpecObj.reportDefinitionListSpec.busClassSpec.actions, actionName);
            const dataViewList: LMDataView[] = listPagingResponse.dataViewSet.data;
            if (dataViewList.length === 1) {
              if (this.lmContextService.isActionSpecRefactorOn()) {
                const instanceActionUrl = this.lmListTransactionService.createActionRedirectUrl(listContext, actionSpec, listPagingResponse.dataViewSet, dataViewList);
                this.lmSpecService.getRedirectUrl(instanceActionUrl, listContext.stepUpActionResult).subscribe(redirectResponse => {
                  if (((redirectResponse as LMSystemException) as LMSystemException)
                    && ((redirectResponse as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR
                      || (redirectResponse as LMSystemException).status === AppConstants.STATUS_UNAUTHORIZED)) {
                    const rResponse = redirectResponse as LMSystemException;
                    this.lmErrorUtilService.handleError(rResponse.message, rResponse.details, rResponse.status, rResponse.message);
                    return;
                  }

                  if (redirectResponse.mfaUrl) {
                    this.lmGlobalUtilService.navigate(redirectResponse.mfaUrl);
                    // window.location.href = redirectResponse.mfaUrl;
                    return;
                  }

                  this.lmBusyIndicatorService.showBusyIndicator();
                  const lmActionInfo: LMActionInfo = {
                    actionName: actionSpec.name,
                    hasActionForm: redirectResponse.hasActionForm,
                    redirectUrl: redirectResponse.redirectUrl
                  };
                  this.executeReportDefinitionAction(listContext, actionSpec, lmActionInfo, listPagingResponse.dataViewSet, dataViewList);
                });
              } else {
                this.executeReportDefinitionAction(listContext, actionSpec, undefined, listPagingResponse.dataViewSet, dataViewList);
              }
            } else {
              this.lmLoggerService.log('Warning: problem in Report Catalog > getReportDefinitionRecordDataView with report: ' + report.id);
            }

          } else {
            this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
              listPagingResponse.status, listPagingResponse.message);
          }
        },
        (error: any) => {
          this.lmBusyIndicatorService.hideBusyIndicator();
          this.lmErrorUtilService.handleUnexpectedError(error);
        });
    }
  }

  private executeReportDefinitionAction(listContext: LMListContext, actionSpec: LMActionSpec, lmActionInfo: LMActionInfo, dataViewSet: LMDataViewSet, dataViewList: LMDataView[]) {
    this.lmListTransactionService.runInstanceAction(listContext, actionSpec, lmActionInfo, dataViewSet, dataViewList).subscribe(
      (transactionState: LMTransactionState) => {

        this.lmBusyIndicatorService.hideBusyIndicator();

        if (transactionState.isError) {
          this.lmErrorUtilService.handleError(
            transactionState.response.message,
            transactionState.response.details,
            transactionState.response.status,
            transactionState.response.message);
        } else if (transactionState.isCanceled) {
          // noop
        } else if (transactionState.isFinished) {
          const resultList = transactionState.completedTransactionList;
          if (resultList[0]?.actionSpec?.name !== 'VisitReport') {
            this.lmGlobalUtilService.displayToastMessage('', resultList[0].message, AppConstants.TRA_ACTION_COMPLETED);
            this.reloadReports();
          }
        }
      });
  }

  private runCopyReport(report: LMReport) {
    let reportType: LMReportType = 'ReportCopiedFromReport';

    if (report.id === report.resourceId) {
      reportType = 'ReportCopiedFromList';
      this.lmCreateReportDialogService.reportType = reportType;
      this.lmCreateReportDialogService.businessClass = report.busClass;
      this.lmCreateReportDialogService.listName = report.name;
      report.id = undefined;
    } else {
      this.lmCreateReportDialogService.userFolder = report.id;
    } 

    this.subscriptionsArray.push(
      this.lmCreateReportDialogService.loadData().subscribe((displayFields: unknown[]) => {
        this.runReportPersonalization(report, {
          reportType,
          mode: 'createReportFromMenu',
        }, false);
      })
    );
  }

  private handleSpecResponseError(response: LMSystemException) {
    this.hideBusyIndicator();
    const statusText = response.statusText;
    const details = response.details;
    this.lmErrorUtilService.handleError(statusText, details);
  }

  onTabActivated(event: SohoTabsEvent) {
    if (!this.initializeSohoTabs) {
      const activeTabId = event.tab.getAttribute('href').slice(1); // Removes '#' from beginning of id
      const curActiveTab = this.lmReportsCatalogService.getActiveTab();
      if  (activeTabId !== curActiveTab && activeTabId !== this.printFilesTabTitle) {
        this.lmReportsCatalogService.setActiveTab(activeTabId);
      }
      if (activeTabId === this.TAB_ID_PRINTFILES && this.doRetrievePrintFilesSpec) {
        this.doRetrievePrintFilesSpec = false;
        this.lmBusyIndicatorService.showBusyIndicator();
        this.retrievePrintPanelSpecs();
      }
    }
  }

  onWidgetRefresh(widget: string) {
    if ('print-queue' === widget) {
      this.lmListPrintQueueComponent?.refresh().subscribe();
    } else if ('scheduled' === widget) {
      this.lmListPrintScheduledComponent?.refresh().subscribe();
    }
  }

  private setCreateReportUrls(urls) {
    this.createReportUrl = urls.createReportUrl;
    this.actorGroupSelectUrl = urls.actorGroupSelectUrl;
    this.roleSelectUrl = urls.roleSelectUrl;
    this.roleGroupSelectUrl = urls.roleGroupSelectUrl;
    this.reportFieldSearchUrl = urls.reportFieldSearchUrl;
  }

  private pageAnalytics() {
    const loadTime = this.lmLoggerService.timeEnd('>> Reports Catalog' + this.instanceId, [ this, 'retrieveReportsCatalogSpecJSON()', 'end' ]);
    const componentInfo = this.getComponentInfo();
    this.lmComponentTrackerService.endLoadTracking(this.route?.routeConfig?.component?.name, this.router.url, componentInfo, loadTime);
    this.lmComponentTrackerService.startComponentTracking(componentInfo, loadTime);
  }

  getComponentInfo(): LMComponentInfo {
    const formInfo: LMComponentInfo = {
      componentType: 'REPORTS_CATALOG',
      name: 'ReportsCatalog',
      userWebRequestId: this.getUserWebRequestId(),
      type: 'page',
      developer: false,
      isWizard: false,
      panelNavigation: false,
      hasConfigAccess: false,
    };
    return formInfo;
  }

  getComponentPlaceHolder(): ViewContainerRef {
    return undefined;
  }

  public getUserWebRequestId(): string {
    return 'ReportsCatalog' + '-' +this.getBaseCompId();
  }

  // Needed to prevent "Reload site?" popup
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  saveComponentState(includeSubComponents?: boolean): void {}

  checkSaveRequired(fromUnifiedMenu?: boolean): boolean {
    return (this.isModified() || this.modalNavigationBlocked(fromUnifiedMenu));
  }

  public isModified(): boolean {
    return false; // assume the lists on the Print Files tab are readonly
  }

  public disableReportsTab(): boolean {
    const context = this.lmContextService.getContext();
    return this.lmContextService.insideInforMobileHub() || context.configuredFeatures.includes('HideMenuReports');
  }

  public allowPageNavigation(nextState?: RouterStateSnapshot, fromUnifiedMenu?: boolean): Promise<boolean> {
    // Skip angular route guard dirty check if it was already done by the unified Portal menu.
    if (this.dirtyCheckComplete) {
      this.dirtyCheckComplete = false;
      return Promise.resolve(true);
    }

    const hasUnsavedChanges = this.checkSaveRequired(fromUnifiedMenu);

    if (!hasUnsavedChanges) {
      this.dirtyCheckComplete = true;
      this.closeModals();
      return Promise.resolve(true);
    }

    if (this.modalNavigationBlocked(fromUnifiedMenu)) {
      const youMayNavigateSource = new BehaviorSubject<boolean>(false);
      const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
      // let's just ask if they want to stay,
      // difficult to determine the modal's purpose - it may run an action or it may just return unsaved data
      this.displayNavigationConfirmation().then((continueOn) => {
        if (continueOn) { // leave
          this.dirtyCheckComplete = true;
          this.closeModals();
        }
        youMayNavigateSource.next(continueOn);
        youMayNavigateSource.complete();
      });
      return lastValueFrom(youMayNavigate);
    } else {
      this.closeModals();
      return Promise.resolve(true);
    }
  }
}
